import { Controller } from "@hotwired/stimulus"

// Reopens the CookieScript consent panel from the footer.
//
// Privacy Policy Section 9.2 tells members they can "use the cookie preferences
// link in our site footer to accept or reject analytics and advertising cookies
// at any time." This controller is the second half of that sentence; the
// type="text/plain" tags in layouts/application.html.erb are the first.
//
// The link ships hidden and reveals itself only once CookieScript has actually
// loaded. That matters because CookieScript is a third-party CDN script that is
// deliberately not loaded everywhere (sign-in and sign-up skip it), and is the
// first thing an ad blocker drops. A permanently dead "Cookie Preferences" link
// in the footer would be a worse failure than no link: the policy would be
// pointing members at a control that silently does nothing. Better to show it
// only where it works.
//
// Revealing rather than hiding is also the safe default for the no-JS path —
// without JavaScript there is no consent panel to open, and no link appears.
export default class extends Controller {
  static targets = ["wrapper"]

  // CookieScript loads async from a CDN, so it is usually absent on connect.
  // Poll briefly rather than racing it, then give up quietly.
  static POLL_MS = 250
  static TIMEOUT_MS = 10000

  connect() {
    this.deadline = Date.now() + this.constructor.TIMEOUT_MS
    this.reveal()
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  reveal() {
    if (this.available) {
      this.wrapperTarget.hidden = false
      return
    }
    if (Date.now() > this.deadline) return
    this.timer = setTimeout(() => this.reveal(), this.constructor.POLL_MS)
  }

  open(event) {
    event.preventDefault()
    if (this.available) window.CookieScript.instance.show()
  }

  get available() {
    const cs = window.CookieScript
    return !!(cs && cs.instance && typeof cs.instance.show === "function")
  }
}
